import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";
import { useNavigate } from "react-router-dom";
import PrepareDataTable from "./PrepareDataTable";
import { SiteListContainer, Title } from "./SiteList.styled";
import UserInfo from "@utils/UserInfo";

import "./SiteList.scss";

/**
 * Site List,
 * Path - /sites
 * @see See [Sites Requirements](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/2944008228/Company+view+page+-+Sites)
 * @component
 */
const SiteList = (props) => {
  const { t, columnList, objectId, objectType, countryId } = props;

  const history = useNavigate();
  const [isRefreshList, setIsRefreshList] = useState(false);
  const [defaultCountryId, setDefaultCountryId] = useState("");
  const [selectedCountryForFilter, setSelectedCountryForFilter] = useState([]);

  const userCountryId = UserInfo.countryId();
  const countryList = UserInfo.countryListForFilter(t);

  const updateRefeshStatus = () => {
    setIsRefreshList(true);
  };

  const createNewSite = () => {
    if (objectId) history(`/${objectId}/site/create`);
    else history(`/site/create`);
  };

  useEffect(() => {
    if (isRefreshList) {
      setIsRefreshList(false);
    }
  }, [isRefreshList]);

  useEffect(() => {
    const effectiveCountryId = countryId ?? userCountryId;
    const selectedCountry = countryList.find(
      (data) => data.value === effectiveCountryId
    );
    setSelectedCountryForFilter(selectedCountry);
    setDefaultCountryId(effectiveCountryId);
  }, []);

  return (
    <SiteListContainer className="site-list">
      <Title>{t("SITES")}</Title>
      {defaultCountryId && (
        <PrepareDataTable
          isRefreshList={isRefreshList}
          updateRefeshStatus={updateRefeshStatus}
          objectId={objectId ? parseInt(objectId, 10) : objectId}
          objectType={objectType}
          columnList={columnList}
          createNewSite={createNewSite}
          countryId={defaultCountryId}
          mainCountryInfo={selectedCountryForFilter}
        />
      )}
    </SiteListContainer>
  );
};

SiteList.propTypes = {
  t: PropTypes.func.isRequired,
  objectType: PropTypes.string,
  columnList: PropTypes.arrayOf(PropTypes.string),
  countryId: PropTypes.number,
};

SiteList.defaultProps = {
  columnList: [],
  objectType: null,
  countryId: null,
};
export default withTranslation()(SiteList);
